// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BLOGS_ADD_NEW_COMMENT_PLACEHOLDER = "Za\u010dni p\u00edsa\u0165 koment\u00e1r...";
export const FORUM_COMMENT_FORM_EMPTY_MESSAGE_CANNOT_BE_SENT = "Pr\u00e1zdnu spr\u00e1vu nem\u00f4\u017ee\u0161 odosla\u0165";
export const SEND_AS_ADMIN = "oznam Modr\u00e9ho kon\u00edka";
export const SEND_COMMENT_FORUM = "Odo\u0161li";
